import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Divider,
} from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import axios from "axios";
import CardPreview from "./CardPreview";

const CardView = () => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCards = async () => {
      try {
        const res = await axios.get("http://localhost:8000/api/cards", {
          withCredentials: true, // 🔑 required if Sanctum is used
        });
        // ✅ Laravel resource wrap check
        setCards(res.data.data || res.data || []);
      } catch (err) {
        console.error("Error fetching cards:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCards();
  }, []);

  if (loading) {
    return (
      <Paper
        sx={{
          mt: { xs: 2, md: 0 },
          p: 3,
          flex: 1,
          minWidth: { xs: "100%", sm: 280 },
          height: "100%",
        }}
      >
        <Typography textAlign="center">Loading...</Typography>
      </Paper>
    );
  }

  return (
    <Paper
      sx={{
        mt: { xs: 2, md: 0 }, // ✅ spacing consistent across screen sizes
        p: 3,
        flex: 1,              // ✅ allow equal growth inside Grid/Flex
        minWidth: { xs: "100%", sm: 280 }, // ✅ responsive minimum width
        height: "100%",       // ✅ keeps all widgets aligned in height
      }}
    >
      {/* Header */}
      <Typography variant="subtitle1" fontWeight="bold">
        Your Cards
      </Typography>
      <Divider sx={{ my: 2 }} />

      {/* Content */}
      {cards.length > 0 ? (
        <Box display="flex" flexDirection="column" gap={2}>
          {cards.map((card) => (
            <CardPreview key={card.id} card={card} />
          ))}
        </Box>
      ) : (
        <Box textAlign="center">
          {/* Credit Card Icon */}
          <Box
            sx={{
              my: 2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: 60,
                height: 60,
                borderRadius: "50%",
                border: "2px solid",
                borderColor: "text.disabled",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CreditCardIcon sx={{ fontSize: 36, color: "text.disabled" }} />
            </Box>
          </Box>

          <Typography variant="body2" color="text.secondary">
            No cards yet
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            You haven't applied for any virtual cards yet. Apply for a new card
            to get started with secure online payments.
          </Typography>

          <Button
            variant="contained"
            sx={{
              mt: 2,
              backgroundColor: "#3b82f6",
              borderRadius: 2,
              px: 3,
              color: "white",
              textTransform: "none",
            }}
          >
            + Apply for Card
          </Button>
        </Box>
      )}
    </Paper>
  );
};

export default CardView;